import React, { useState } from 'react';

const SearchBar = ({ searchTerm, onSearchChange, className = "", onSearchStateChange, onClearSearch }) => {
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const handleSearchToggle = (open) => {
    setIsSearchOpen(open);
    if (onSearchStateChange) {
      onSearchStateChange(open);
    }
  };

  const handleCloseSearch = () => {
    handleSearchToggle(false);
    onSearchChange(''); // Reset search term
    if (onClearSearch) {
      onClearSearch(); // Notify parent that search was cleared
    }
  };

  return (
    <div className={`${className}`}>
      {/* Desktop: Always show full search bar */}
      <div className="hidden md:block relative">
        <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
          <svg className="h-5 w-5 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </div>
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Buscar por marca, modelo..."
          className="w-full pl-12 pr-4 py-4 text-lg border border-slate-300 rounded-2xl focus:ring-2 focus:ring-sky-500 focus:border-transparent bg-white shadow-sm transition-all duration-200 hover:shadow-md"
        />
      </div>

      {/* Mobile: Show magnifying glass icon that toggles search input */}
      <div className="md:hidden">
        {isSearchOpen ? (
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
              <svg className="h-5 w-5 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </div>
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder="Buscar por marca, modelo..."
              className="w-full pl-12 pr-12 py-4 text-lg border border-slate-300 rounded-2xl focus:ring-2 focus:ring-sky-500 focus:border-transparent bg-white shadow-sm transition-all duration-200 hover:shadow-md"
              autoFocus
            />
            <button
              onClick={handleCloseSearch}
              className="absolute inset-y-0 right-0 pr-4 flex items-center"
            >
              <svg className="h-5 w-5 text-slate-400 hover:text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        ) : (
          <button
            onClick={() => handleSearchToggle(true)}
            className="p-3 bg-sky-50 border border-sky-200 rounded-2xl shadow-sm hover:shadow-md transition-all duration-200 focus:ring-2 focus:ring-sky-500 focus:border-transparent"
          >
            <svg className="h-6 w-6 text-sky-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchBar;
